export enum HomepageStatus {
    RegisterAccount = 0,
    Login
}
